import { isEqual } from 'lodash';
import { removeOptions } from '../../_Components/Fields/NestedInputs/helpers/remove';

export const removeUndefinedKey = obj => {
  const newObj = {};
  Object.keys(obj).map(key => {
    if (typeof obj[key] === 'object' && obj[key] !== null && obj[key]?.length !== 0) {
      newObj[key] = removeUndefinedKey(obj[key]);
    } else if (obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
    return newObj;
  });
  return newObj;
};

export const removeNormalFilter = (existingFilters, filterValue) =>
  existingFilters.filter(filter => !isEqual(filter, removeUndefinedKey(filterValue)));

export const removeNormalIterationFilter = (existingFilters, filterValue) =>
  existingFilters.filter(filter => !isEqual(filter.option.id, filterValue.option.id));

export const removeThematicFilter = (existingFilters, filterValue, parentKey) =>
  removeOptions([filterValue], existingFilters, parentKey);

export const FILTERS_REMOVE_STRATEGIES = {
  thematic: removeThematicFilter,
  thematics: removeThematicFilter,
  criteriaKeys: removeThematicFilter,
  normal: removeNormalFilter,
  default: removeNormalFilter,
};
